import Vue from 'vue'
import i18n from './locales/index.js';
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import Vuex from 'vuex';
import store from './store/index.js';
import 'babel-polyfill';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false;
import 'swiper/css/swiper.min.css';
import 'swiper/js/swiper.min.js';
import './assets/css/public.scss';
import dayjs from 'dayjs'
import './assets/css/index.css'
import './assets/css/mobileTerminal.scss'
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.prototype.dayjs = dayjs;


Vue.prototype.$resetSetItem = function (key, newVal) {
  if (key === 'languageSet') {
    let newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val);
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}
router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  render: function (createElement) {
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
    return createElement(App);
  }
})



// WEBPACK FOOTER //
// ./src/main.js